"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollWrapStyled = exports.HeaderWrapStyled = exports.ImageWrapp = exports.ItemWrap = exports.IconLeftStyles = exports.ButtonWrapp = exports.Line2 = exports.Line1 = exports.Grid = exports.GridItem = exports.Container = void 0;

var _styledComponents = require("styled-components");

var _uiKit = require("@dbi-tools/ui-kit");

var _headerTitles = require("../header-titles/header-titles.styled");

var _themeOptions = require("../../helpers/theme-options");

var _helpers = require("./helpers");

var _types = require("./types");

var _lineStyles = _interopRequireDefault(require("./../../helpers/lineStyles"));

var _styled = require("../../styled");

var _carousel = require("../carousel/carousel.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  .slick-list {\n    padding: 0 30px;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  max-width: 930px;\n  width: 100%;\n  margin: 0 auto;\n  ", " {\n    width: 100%;\n    text-align: ", ";\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block !important;\n\n  ", " {\n    position: static;\n    width: 70px;\n  }\n\n  img,\n  ", " {\n    height: 70px;\n    ", " {\n      display: flex !important;\n      justify-content: center;\n    }\n\n    ", " {\n      ", ";\n    }\n\n    ", " {\n      ", " {\n        ", ";\n      }\n    }\n  }\n\n  ", " {\n    display: flex !important;\n    ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: calc(100% - 86px);\n\n  ", " {\n    height: calc(100% - 80px);\n  }\n\n  ", " {\n    ", ";\n  }\n  ", " {\n    ", " {\n      ", ";\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  min-width: 180px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n  margin-top: 10px;\n  p {\n    margin: 0;\n  }\n  a {\n    color: inherit;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 30px;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1116px;\n  justify-content: center;\n\n  ", "\n  ", "\n\n  ", " {\n    padding: 0 15px;\n\n    ", "\n\n    ", "\n  }\n\n  ", " {\n    padding: ", ";\n    .slick-slider {\n      .slick-control {\n        top: 50%;\n        margin-top: -10px;\n        ", "\n        &:first-child {\n          left: -45px;\n        }\n        &:last-child {\n          right: -45px;\n        }\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  flex: 0 1 342px;\n  margin: 15px;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), function (_ref) {
  var _ref$theme$$theme = _ref.theme.$theme,
      $theme = _ref$theme$$theme === void 0 ? _themeOptions.ThemeNoCardVariants.WHITE : _ref$theme$$theme;
  return (0, _helpers.getTheme)($theme);
});
exports.Container = Container;
var GridItem = (0, _uiKit.styled)(_uiKit.Box)(_templateObject2(), _uiKit.Colors.white);
exports.GridItem = GridItem;
var Grid = (0, _uiKit.styled)(_uiKit.Box)(_templateObject3(), function (_ref2) {
  var $columns = _ref2.theme.$columns;
  return (0, _helpers.getGridStyles)(parseInt($columns));
}, function (_ref3) {
  var $textAlign = _ref3.theme.$textAlign;
  return $textAlign && (0, _styledComponents.css)(["text-align:", ";"], $textAlign);
}, _uiKit.GridBreakpointsMediaDown.lg, function (_ref4) {
  var mobileLayout = _ref4.mobileLayout;
  return (0, _helpers.getMobLayoutStyles)(mobileLayout);
}, function (_ref5) {
  var hideMd = _ref5.hideMd;
  return hideMd && "\n      display: none;\n    ";
}, _uiKit.GridBreakpointsMediaDown.sm, function (_ref6) {
  var mobileLayout = _ref6.mobileLayout;
  return mobileLayout === _types.KeyValueLayoutType.carousel ? "0 50px" : "0 24px";
}, _carousel.CarouselDefaultArrowStyles);
exports.Grid = Grid;
var Line1 = (0, _uiKit.styled)("h4")(_templateObject4(), _styled.Line1Styles, function (_ref7) {
  var $styles = _ref7.theme.$styles;
  return $styles ? (0, _lineStyles.default)({
    styles: $styles,
    parent: 'icon-card',
    line: 'headline1'
  }) : '';
});
exports.Line1 = Line1;
var Line2 = (0, _uiKit.styled)("div")(_templateObject5(), _styled.Line2Styles, function (_ref8) {
  var $styles = _ref8.theme.$styles;
  return $styles ? (0, _lineStyles.default)({
    styles: $styles,
    parent: 'icon-card',
    line: 'headline2'
  }) : '';
});
exports.Line2 = Line2;
var ButtonWrapp = (0, _uiKit.styled)(_uiKit.Box)(_templateObject6());
exports.ButtonWrapp = ButtonWrapp;
var IconLeftStyles = /*#__PURE__*/(0, _styledComponents.css)(["height:auto;max-width:70px;"]);
exports.IconLeftStyles = IconLeftStyles;
var ItemWrap = (0, _uiKit.styled)(_uiKit.Box)(_templateObject7(), _uiKit.GridBreakpointsMediaDown.md, _uiKit.GridBreakpointsMediaUp.xl, function (_ref9) {
  var isIconLeftDesktop = _ref9.isIconLeftDesktop;
  return isIconLeftDesktop && "height: inherit;";
}, _uiKit.GridBreakpointsMediaDown.xl, _uiKit.GridBreakpointsMediaUp.md, function (_ref10) {
  var isIconLeftTablet = _ref10.isIconLeftTablet;
  return isIconLeftTablet && "height: inherit;";
});
exports.ItemWrap = ItemWrap;
var ImageWrapp = (0, _uiKit.styled)("span")(_templateObject8(), _uiKit.LoadingBlockStyled, _uiKit.LoadingBlockStyled, _uiKit.GridBreakpointsMediaDown.md, _uiKit.GridBreakpointsMediaUp.xl, function (_ref11) {
  var isIconLeftDesktop = _ref11.isIconLeftDesktop;
  return isIconLeftDesktop && IconLeftStyles;
}, _uiKit.GridBreakpointsMediaDown.xl, _uiKit.GridBreakpointsMediaUp.md, function (_ref12) {
  var isIconLeftTablet = _ref12.isIconLeftTablet;
  return isIconLeftTablet && IconLeftStyles;
}, _uiKit.GridBreakpointsMediaDown.md, function (_ref13) {
  var alignCenter = _ref13.alignCenter;
  return alignCenter && 'justify-content: center;';
});
exports.ImageWrapp = ImageWrapp;
var HeaderWrapStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject9(), _headerTitles.DescriptionStyled, function (_ref14) {
  var $textAlign = _ref14.theme.$textAlign;
  return $textAlign;
});
exports.HeaderWrapStyled = HeaderWrapStyled;
var ScrollWrapStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject10());
exports.ScrollWrapStyled = ScrollWrapStyled;